import React from 'react'

const Footer = () => {
  return (
    
    <footer className="footer bg-white text-center text-muted border-top py-3 px-4 fixed-bottom">
      <div className="container d-flex justify-content-between align-items-center">
        <p className="mb-0">© 2025 Manlab S.A.</p>
      </div>

      {/* <ul className="nav col-md-4 justify-content-end">
        <li className="nav-item"><a href="#" className="nav-link px-2 text-muted">Home</a></li>
        <li className="nav-item"><a href="#" className="nav-link px-2 text-muted">Features</a></li>
        <li className="nav-item"><a href="#" className="nav-link px-2 text-muted">Pricing</a></li>
        <li className="nav-item"><a href="#" className="nav-link px-2 text-muted">FAQs</a></li>
        <li className="nav-item"><a href="#" className="nav-link px-2 text-muted">About</a></li>
      </ul> */}
      
    </footer>


  )
}

export default Footer